angular.module('ui-ng-notification', [
  'ngSanitize',
  'ui-ng-delegate',
  'utility-ng-interface',
  'utility-ng-enumeration'
]);



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-notification/src/core.js